/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {reportDeeplink} from '../api'

export const useMutationReportDeeplink = createReactQueryMutationHook('reportDeeplink', reportDeeplink)
